import edit from "./edit";
import id from "./id";

export default {
    edit,
    id
}